import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import { ChevronDownOutline } from '@olist/design-system-icons';
import { isValidElementType } from 'react-is';
import { useSelect, clearFilteredOptions, searchOptions } from './SelectContext.js';
import { TextSuffix } from './styles.js';
import { Flex } from '../Flex/Flex.js';
import { Input } from '../Input/Input.js';
import '../Input/InputBody.js';
import '../Input/InputPassword/styles.js';

const renderTextClosedInputValue = ({ hasLessThanThreeSelectedOptions, selectedOptionsText, textClosedInputValue, }) => {
    if (hasLessThanThreeSelectedOptions) {
        return selectedOptionsText.join(', ');
    }
    if (textClosedInputValue) {
        return `${selectedOptionsText.length} ${textClosedInputValue}`;
    }
    return `${selectedOptionsText.length} itens`;
};
const SelectInput = forwardRef((_a, ref) => {
    var { label, id, isInputFocused, onFocus, onChange, textClosedInputValue, handleFocus: handleInputFocus, suffix: CustomSuffix } = _a, props = __rest(_a, ["label", "id", "isInputFocused", "onFocus", "onChange", "textClosedInputValue", "handleFocus", "suffix"]);
    const [{ searchedTerm, options, minSearchChars }, dispatch] = useSelect();
    const selectedOptionsText = options
        .filter((option) => option.selected)
        .map((option) => option.text);
    const hasLessThanThreeSelectedOptions = selectedOptionsText.length < 3;
    const closedInputValue = renderTextClosedInputValue({
        hasLessThanThreeSelectedOptions,
        selectedOptionsText,
        textClosedInputValue,
    });
    const inputValue = isInputFocused ? searchedTerm : closedInputValue;
    const handleInputChange = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
        if (!event.target.value) {
            clearFilteredOptions(dispatch);
            searchOptions(dispatch, '');
            return;
        }
        searchOptions(dispatch, event.target.value, minSearchChars);
    };
    const handleFocus = (event) => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
        if (selectedOptionsText.length) {
            searchOptions(dispatch, '');
        }
    };
    const hasCustomSuffix = !!CustomSuffix;
    const renderCustomSuffixAsElement = hasCustomSuffix &&
        isValidElementType(CustomSuffix) &&
        typeof CustomSuffix !== 'string';
    return (React.createElement(Input, Object.assign({}, props, { ref: ref, label: label, id: id, suffix: React.createElement(Flex, { gap: "inline.small", alignItems: "center" },
            React.createElement(ChevronDownOutline, { "aria-hidden": true, onClick: handleInputFocus }),
            hasCustomSuffix && (React.createElement(React.Fragment, null, renderCustomSuffixAsElement ? (React.createElement(CustomSuffix, { "aria-hidden": "true" })) : (React.createElement(TextSuffix, null, CustomSuffix))))), onChange: handleInputChange, onFocus: handleFocus, value: inputValue, autoComplete: "off", style: { textOverflow: 'ellipsis' } })));
});
SelectInput.displayName = 'SelectInput';

export { SelectInput };
